import {Model} from "./";
import {Api} from "../api";

class Request1cModel extends Model {

    constructor() {
        super(new Api("/request-1c"));
    }

    createRegAll(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/user');
        this.q.create(data, thenFunction, errorFunction);
    }
    createTradePoint(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/trade-point');
        this.q.create(data, thenFunction, errorFunction);
    }

    getCity(q, thenFunction, errorFunction) {
        this.q.setDopUrl('/city');
        this.q.read({q: q}, thenFunction, errorFunction);
    }

    findNotEmailConfirmed(thenFunction, errorFunction) {
        this.q.setDopUrl('/not-email-confirmed');
        this.q.read({}, thenFunction, errorFunction);
    }

    getCheckEmail(code, thenFunction, errorFunction) {
        this.q.setDopUrl('/email/' + code);
        this.q.read({}, thenFunction, errorFunction);
    }
    deleteUser(id, thenFunction, errorFunction) {
        this.q.setDopUrl('/' + id);
        this.q.delete({}, thenFunction, errorFunction);
    }

    updateUser(id,newEmail, thenFunction, errorFunction) {
        this.q.setDopUrl('/' + id);
        this.q.update({email: newEmail}, thenFunction, errorFunction);
    }
    sendEmailReplay(userId, thenFunction, errorFunction) {
        this.q.setDopUrl('/replay');
        this.q.create({id: userId}, thenFunction, errorFunction);
    }
}

export default new Request1cModel();